var cov_2b9jlkjgt = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/is.ts",
      hash = "76bb45ac55796ba0c721448f29f2d86448b8a853",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/is.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 15
        },
        end: {
          line: 9,
          column: 2
        }
      },
      "1": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 7,
          column: 3
        }
      },
      "2": {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 66
        }
      },
      "3": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 14
        }
      },
      "4": {
        start: {
          line: 11,
          column: 23
        },
        end: {
          line: 11,
          column: 36
        }
      },
      "5": {
        start: {
          line: 12,
          column: 23
        },
        end: {
          line: 12,
          column: 57
        }
      },
      "6": {
        start: {
          line: 12,
          column: 48
        },
        end: {
          line: 12,
          column: 57
        }
      },
      "7": {
        start: {
          line: 13,
          column: 26
        },
        end: {
          line: 13,
          column: 60
        }
      },
      "8": {
        start: {
          line: 13,
          column: 51
        },
        end: {
          line: 13,
          column: 60
        }
      },
      "9": {
        start: {
          line: 15,
          column: 21
        },
        end: {
          line: 15,
          column: 53
        }
      },
      "10": {
        start: {
          line: 15,
          column: 46
        },
        end: {
          line: 15,
          column: 53
        }
      },
      "11": {
        start: {
          line: 16,
          column: 22
        },
        end: {
          line: 16,
          column: 76
        }
      },
      "12": {
        start: {
          line: 16,
          column: 53
        },
        end: {
          line: 16,
          column: 76
        }
      },
      "13": {
        start: {
          line: 17,
          column: 24
        },
        end: {
          line: 17,
          column: 74
        }
      },
      "14": {
        start: {
          line: 17,
          column: 53
        },
        end: {
          line: 17,
          column: 74
        }
      },
      "15": {
        start: {
          line: 18,
          column: 24
        },
        end: {
          line: 18,
          column: 106
        }
      },
      "16": {
        start: {
          line: 18,
          column: 57
        },
        end: {
          line: 18,
          column: 106
        }
      },
      "17": {
        start: {
          line: 19,
          column: 24
        },
        end: {
          line: 19,
          column: 74
        }
      },
      "18": {
        start: {
          line: 19,
          column: 53
        },
        end: {
          line: 19,
          column: 74
        }
      },
      "19": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 20,
          column: 68
        }
      },
      "20": {
        start: {
          line: 20,
          column: 49
        },
        end: {
          line: 20,
          column: 68
        }
      },
      "21": {
        start: {
          line: 21,
          column: 23
        },
        end: {
          line: 21,
          column: 70
        }
      },
      "22": {
        start: {
          line: 21,
          column: 50
        },
        end: {
          line: 21,
          column: 70
        }
      },
      "23": {
        start: {
          line: 22,
          column: 24
        },
        end: {
          line: 22,
          column: 72
        }
      },
      "24": {
        start: {
          line: 22,
          column: 51
        },
        end: {
          line: 22,
          column: 72
        }
      },
      "25": {
        start: {
          line: 23,
          column: 21
        },
        end: {
          line: 23,
          column: 34
        }
      },
      "26": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 34
        }
      },
      "27": {
        start: {
          line: 25,
          column: 24
        },
        end: {
          line: 25,
          column: 40
        }
      },
      "28": {
        start: {
          line: 26,
          column: 25
        },
        end: {
          line: 27,
          column: 69
        }
      },
      "29": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 27,
          column: 69
        }
      },
      "30": {
        start: {
          line: 29,
          column: 26
        },
        end: {
          line: 29,
          column: 118
        }
      },
      "31": {
        start: {
          line: 29,
          column: 105
        },
        end: {
          line: 29,
          column: 118
        }
      },
      "32": {
        start: {
          line: 31,
          column: 24
        },
        end: {
          line: 34,
          column: 1
        }
      },
      "33": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 31
        }
      },
      "34": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 32,
          column: 31
        }
      },
      "35": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 71
        }
      },
      "36": {
        start: {
          line: 35,
          column: 23
        },
        end: {
          line: 47,
          column: 1
        }
      },
      "37": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 36,
          column: 30
        }
      },
      "38": {
        start: {
          line: 36,
          column: 19
        },
        end: {
          line: 36,
          column: 30
        }
      },
      "39": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 29
        }
      },
      "40": {
        start: {
          line: 38,
          column: 18
        },
        end: {
          line: 38,
          column: 29
        }
      },
      "41": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 40,
          column: 103
        }
      },
      "42": {
        start: {
          line: 40,
          column: 56
        },
        end: {
          line: 40,
          column: 103
        }
      },
      "43": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 42,
          column: 39
        }
      },
      "44": {
        start: {
          line: 42,
          column: 27
        },
        end: {
          line: 42,
          column: 39
        }
      },
      "45": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 44,
          column: 67
        }
      },
      "46": {
        start: {
          line: 44,
          column: 31
        },
        end: {
          line: 44,
          column: 67
        }
      },
      "47": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 46,
          column: 14
        }
      },
      "48": {
        start: {
          line: 49,
          column: 24
        },
        end: {
          line: 54,
          column: 1
        }
      },
      "49": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 52,
          column: 3
        }
      },
      "50": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 49
        }
      },
      "51": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 53,
          column: 14
        }
      },
      "52": {
        start: {
          line: 56,
          column: 27
        },
        end: {
          line: 65,
          column: 1
        }
      },
      "53": {
        start: {
          line: 57,
          column: 2
        },
        end: {
          line: 57,
          column: 34
        }
      },
      "54": {
        start: {
          line: 57,
          column: 22
        },
        end: {
          line: 57,
          column: 34
        }
      },
      "55": {
        start: {
          line: 58,
          column: 14
        },
        end: {
          line: 58,
          column: 65
        }
      },
      "56": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 62,
          column: 3
        }
      },
      "57": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 33
        }
      },
      "58": {
        start: {
          line: 61,
          column: 21
        },
        end: {
          line: 61,
          column: 33
        }
      },
      "59": {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 64,
          column: 13
        }
      },
      "60": {
        start: {
          line: 67,
          column: 21
        },
        end: {
          line: 70,
          column: 1
        }
      },
      "61": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 68,
          column: 28
        }
      },
      "62": {
        start: {
          line: 68,
          column: 17
        },
        end: {
          line: 68,
          column: 28
        }
      },
      "63": {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 69,
          column: 84
        }
      },
      "64": {
        start: {
          line: 73,
          column: 25
        },
        end: {
          line: 73,
          column: 94
        }
      },
      "65": {
        start: {
          line: 73,
          column: 50
        },
        end: {
          line: 73,
          column: 94
        }
      },
      "66": {
        start: {
          line: 74,
          column: 29
        },
        end: {
          line: 75,
          column: 112
        }
      },
      "67": {
        start: {
          line: 75,
          column: 2
        },
        end: {
          line: 75,
          column: 112
        }
      },
      "68": {
        start: {
          line: 77,
          column: 22
        },
        end: {
          line: 86,
          column: 1
        }
      },
      "69": {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 83,
          column: 3
        }
      },
      "70": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 47
        }
      },
      "71": {
        start: {
          line: 79,
          column: 35
        },
        end: {
          line: 79,
          column: 47
        }
      },
      "72": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 30
        }
      },
      "73": {
        start: {
          line: 80,
          column: 18
        },
        end: {
          line: 80,
          column: 30
        }
      },
      "74": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 36
        }
      },
      "75": {
        start: {
          line: 81,
          column: 25
        },
        end: {
          line: 81,
          column: 36
        }
      },
      "76": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 68
        }
      },
      "77": {
        start: {
          line: 82,
          column: 57
        },
        end: {
          line: 82,
          column: 68
        }
      },
      "78": {
        start: {
          line: 85,
          column: 2
        },
        end: {
          line: 85,
          column: 14
        }
      },
      "79": {
        start: {
          line: 92,
          column: 28
        },
        end: {
          line: 95,
          column: 1
        }
      },
      "80": {
        start: {
          line: 93,
          column: 2
        },
        end: {
          line: 93,
          column: 41
        }
      },
      "81": {
        start: {
          line: 93,
          column: 29
        },
        end: {
          line: 93,
          column: 41
        }
      },
      "82": {
        start: {
          line: 94,
          column: 2
        },
        end: {
          line: 94,
          column: 41
        }
      },
      "83": {
        start: {
          line: 97,
          column: 23
        },
        end: {
          line: 97,
          column: 85
        }
      },
      "84": {
        start: {
          line: 97,
          column: 38
        },
        end: {
          line: 97,
          column: 85
        }
      },
      "85": {
        start: {
          line: 99,
          column: 25
        },
        end: {
          line: 99,
          column: 97
        }
      },
      "86": {
        start: {
          line: 99,
          column: 40
        },
        end: {
          line: 99,
          column: 97
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 21
          },
          end: {
            line: 4,
            column: 22
          }
        },
        loc: {
          start: {
            line: 4,
            column: 54
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 23
          },
          end: {
            line: 12,
            column: 24
          }
        },
        loc: {
          start: {
            line: 12,
            column: 48
          },
          end: {
            line: 12,
            column: 57
          }
        },
        line: 12
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 13,
            column: 26
          },
          end: {
            line: 13,
            column: 27
          }
        },
        loc: {
          start: {
            line: 13,
            column: 51
          },
          end: {
            line: 13,
            column: 60
          }
        },
        line: 13
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 15,
            column: 21
          },
          end: {
            line: 15,
            column: 22
          }
        },
        loc: {
          start: {
            line: 15,
            column: 46
          },
          end: {
            line: 15,
            column: 53
          }
        },
        line: 15
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 23
          }
        },
        loc: {
          start: {
            line: 16,
            column: 53
          },
          end: {
            line: 16,
            column: 76
          }
        },
        line: 16
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 17,
            column: 24
          },
          end: {
            line: 17,
            column: 25
          }
        },
        loc: {
          start: {
            line: 17,
            column: 53
          },
          end: {
            line: 17,
            column: 74
          }
        },
        line: 17
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 18,
            column: 24
          },
          end: {
            line: 18,
            column: 25
          }
        },
        loc: {
          start: {
            line: 18,
            column: 57
          },
          end: {
            line: 18,
            column: 106
          }
        },
        line: 18
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 19,
            column: 24
          },
          end: {
            line: 19,
            column: 25
          }
        },
        loc: {
          start: {
            line: 19,
            column: 53
          },
          end: {
            line: 19,
            column: 74
          }
        },
        line: 19
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 20,
            column: 23
          }
        },
        loc: {
          start: {
            line: 20,
            column: 49
          },
          end: {
            line: 20,
            column: 68
          }
        },
        line: 20
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 21,
            column: 23
          },
          end: {
            line: 21,
            column: 24
          }
        },
        loc: {
          start: {
            line: 21,
            column: 50
          },
          end: {
            line: 21,
            column: 70
          }
        },
        line: 21
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 22,
            column: 24
          },
          end: {
            line: 22,
            column: 25
          }
        },
        loc: {
          start: {
            line: 22,
            column: 51
          },
          end: {
            line: 22,
            column: 72
          }
        },
        line: 22
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 26,
            column: 25
          },
          end: {
            line: 26,
            column: 26
          }
        },
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 69
          }
        },
        line: 27
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 29,
            column: 26
          },
          end: {
            line: 29,
            column: 27
          }
        },
        loc: {
          start: {
            line: 29,
            column: 105
          },
          end: {
            line: 29,
            column: 118
          }
        },
        line: 29
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 31,
            column: 24
          },
          end: {
            line: 31,
            column: 25
          }
        },
        loc: {
          start: {
            line: 31,
            column: 65
          },
          end: {
            line: 34,
            column: 1
          }
        },
        line: 31
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 35,
            column: 23
          },
          end: {
            line: 35,
            column: 24
          }
        },
        loc: {
          start: {
            line: 35,
            column: 50
          },
          end: {
            line: 47,
            column: 1
          }
        },
        line: 35
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 49,
            column: 24
          },
          end: {
            line: 49,
            column: 25
          }
        },
        loc: {
          start: {
            line: 49,
            column: 51
          },
          end: {
            line: 54,
            column: 1
          }
        },
        line: 49
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 56,
            column: 27
          },
          end: {
            line: 56,
            column: 28
          }
        },
        loc: {
          start: {
            line: 56,
            column: 54
          },
          end: {
            line: 65,
            column: 1
          }
        },
        line: 56
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 67,
            column: 21
          },
          end: {
            line: 67,
            column: 22
          }
        },
        loc: {
          start: {
            line: 67,
            column: 48
          },
          end: {
            line: 70,
            column: 1
          }
        },
        line: 67
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 73,
            column: 25
          },
          end: {
            line: 73,
            column: 26
          }
        },
        loc: {
          start: {
            line: 73,
            column: 50
          },
          end: {
            line: 73,
            column: 94
          }
        },
        line: 73
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 74,
            column: 29
          },
          end: {
            line: 74,
            column: 30
          }
        },
        loc: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 112
          }
        },
        line: 75
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 77,
            column: 22
          },
          end: {
            line: 77,
            column: 23
          }
        },
        loc: {
          start: {
            line: 77,
            column: 65
          },
          end: {
            line: 86,
            column: 1
          }
        },
        line: 77
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 92,
            column: 28
          },
          end: {
            line: 92,
            column: 29
          }
        },
        loc: {
          start: {
            line: 92,
            column: 53
          },
          end: {
            line: 95,
            column: 1
          }
        },
        line: 92
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 97,
            column: 23
          },
          end: {
            line: 97,
            column: 24
          }
        },
        loc: {
          start: {
            line: 97,
            column: 38
          },
          end: {
            line: 97,
            column: 85
          }
        },
        line: 97
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 99,
            column: 25
          },
          end: {
            line: 99,
            column: 26
          }
        },
        loc: {
          start: {
            line: 99,
            column: 40
          },
          end: {
            line: 99,
            column: 97
          }
        },
        line: 99
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 7,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 7,
            column: 3
          }
        }, {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 7,
            column: 3
          }
        }],
        line: 5
      },
      "1": {
        loc: {
          start: {
            line: 6,
            column: 11
          },
          end: {
            line: 6,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 11
          },
          end: {
            line: 6,
            column: 14
          }
        }, {
          start: {
            line: 6,
            column: 18
          },
          end: {
            line: 6,
            column: 33
          }
        }, {
          start: {
            line: 6,
            column: 37
          },
          end: {
            line: 6,
            column: 66
          }
        }],
        line: 6
      },
      "2": {
        loc: {
          start: {
            line: 18,
            column: 57
          },
          end: {
            line: 18,
            column: 106
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 18,
            column: 57
          },
          end: {
            line: 18,
            column: 62
          }
        }, {
          start: {
            line: 18,
            column: 66
          },
          end: {
            line: 18,
            column: 89
          }
        }, {
          start: {
            line: 18,
            column: 93
          },
          end: {
            line: 18,
            column: 106
          }
        }],
        line: 18
      },
      "3": {
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        }, {
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 27,
            column: 28
          }
        }, {
          start: {
            line: 27,
            column: 32
          },
          end: {
            line: 27,
            column: 68
          }
        }],
        line: 27
      },
      "4": {
        loc: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 31
          }
        }, {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 31
          }
        }],
        line: 32
      },
      "5": {
        loc: {
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 33,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 33,
            column: 38
          }
        }, {
          start: {
            line: 33,
            column: 42
          },
          end: {
            line: 33,
            column: 71
          }
        }],
        line: 33
      },
      "6": {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 30
          }
        }, {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 30
          }
        }],
        line: 36
      },
      "7": {
        loc: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 29
          }
        }, {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 29
          }
        }],
        line: 38
      },
      "8": {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 103
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 103
          }
        }, {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 103
          }
        }],
        line: 40
      },
      "9": {
        loc: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 39
          }
        }, {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 39
          }
        }],
        line: 42
      },
      "10": {
        loc: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 67
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 67
          }
        }, {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 67
          }
        }],
        line: 44
      },
      "11": {
        loc: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        }, {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        }],
        line: 50
      },
      "12": {
        loc: {
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 50,
            column: 114
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 50,
            column: 9
          }
        }, {
          start: {
            line: 50,
            column: 13
          },
          end: {
            line: 50,
            column: 36
          }
        }, {
          start: {
            line: 50,
            column: 40
          },
          end: {
            line: 50,
            column: 55
          }
        }, {
          start: {
            line: 50,
            column: 59
          },
          end: {
            line: 50,
            column: 114
          }
        }],
        line: 50
      },
      "13": {
        loc: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 57,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 57,
            column: 34
          }
        }, {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 57,
            column: 34
          }
        }],
        line: 57
      },
      "14": {
        loc: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 61,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 61,
            column: 33
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 61,
            column: 33
          }
        }],
        line: 61
      },
      "15": {
        loc: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 28
          }
        }, {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 28
          }
        }],
        line: 68
      },
      "16": {
        loc: {
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 69,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 69,
            column: 32
          }
        }, {
          start: {
            line: 69,
            column: 36
          },
          end: {
            line: 69,
            column: 59
          }
        }, {
          start: {
            line: 69,
            column: 63
          },
          end: {
            line: 69,
            column: 84
          }
        }],
        line: 69
      },
      "17": {
        loc: {
          start: {
            line: 73,
            column: 50
          },
          end: {
            line: 73,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 73,
            column: 50
          },
          end: {
            line: 73,
            column: 71
          }
        }, {
          start: {
            line: 73,
            column: 75
          },
          end: {
            line: 73,
            column: 94
          }
        }],
        line: 73
      },
      "18": {
        loc: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 112
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 21
          }
        }, {
          start: {
            line: 75,
            column: 25
          },
          end: {
            line: 75,
            column: 36
          }
        }, {
          start: {
            line: 75,
            column: 40
          },
          end: {
            line: 75,
            column: 51
          }
        }, {
          start: {
            line: 75,
            column: 55
          },
          end: {
            line: 75,
            column: 67
          }
        }, {
          start: {
            line: 75,
            column: 71
          },
          end: {
            line: 75,
            column: 81
          }
        }, {
          start: {
            line: 75,
            column: 85
          },
          end: {
            line: 75,
            column: 95
          }
        }, {
          start: {
            line: 75,
            column: 99
          },
          end: {
            line: 75,
            column: 112
          }
        }],
        line: 75
      },
      "19": {
        loc: {
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        }, {
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        }],
        line: 78
      },
      "20": {
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 47
          }
        }, {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 47
          }
        }],
        line: 79
      },
      "21": {
        loc: {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 30
          }
        }, {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 30
          }
        }],
        line: 80
      },
      "22": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 36
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 36
          }
        }],
        line: 81
      },
      "23": {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 68
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 68
          }
        }, {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 68
          }
        }],
        line: 82
      },
      "24": {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 16
          }
        }, {
          start: {
            line: 82,
            column: 20
          },
          end: {
            line: 82,
            column: 55
          }
        }],
        line: 82
      },
      "25": {
        loc: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 93,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 93,
            column: 41
          }
        }, {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 93,
            column: 41
          }
        }],
        line: 93
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0, 0],
      "3": [0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0, 0],
      "17": [0, 0],
      "18": [0, 0, 0, 0, 0, 0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import React from 'react';
import { curry } from './func';
var nameIs = (cov_2b9jlkjgt.s[0]++, curry(function (name, val) {
  cov_2b9jlkjgt.f[0]++;
  cov_2b9jlkjgt.s[1]++;

  if (typeof val === 'object') {
    cov_2b9jlkjgt.b[0][0]++;
    cov_2b9jlkjgt.s[2]++;
    return (cov_2b9jlkjgt.b[1][0]++, val) && (cov_2b9jlkjgt.b[1][1]++, val.constructor) && (cov_2b9jlkjgt.b[1][2]++, val.constructor.name === name);
  } else {
    cov_2b9jlkjgt.b[0][1]++;
  }

  cov_2b9jlkjgt.s[3]++;
  return false;
})); // eslint-disable-next-line

export var isArray = (cov_2b9jlkjgt.s[4]++, Array.isArray);
cov_2b9jlkjgt.s[5]++;
export var isUndef = function isUndef(v) {
  cov_2b9jlkjgt.f[1]++;
  cov_2b9jlkjgt.s[6]++;
  return v == null;
};
cov_2b9jlkjgt.s[7]++;
export var isNotUndef = function isNotUndef(v) {
  cov_2b9jlkjgt.f[2]++;
  cov_2b9jlkjgt.s[8]++;
  return v != null;
}; // eslint-disable-next-line

cov_2b9jlkjgt.s[9]++;
export var isNan = function isNan(a) {
  cov_2b9jlkjgt.f[3]++;
  cov_2b9jlkjgt.s[10]++;
  return a !== a;
};
cov_2b9jlkjgt.s[11]++;
export var isFunc = function isFunc(f) {
  cov_2b9jlkjgt.f[4]++;
  cov_2b9jlkjgt.s[12]++;
  return typeof f === 'function';
};
cov_2b9jlkjgt.s[13]++;
export var isNumber = function isNumber(n) {
  cov_2b9jlkjgt.f[5]++;
  cov_2b9jlkjgt.s[14]++;
  return typeof n === 'number';
};
cov_2b9jlkjgt.s[15]++;
export var isObject = function isObject(val) {
  cov_2b9jlkjgt.f[6]++;
  cov_2b9jlkjgt.s[16]++;
  return (cov_2b9jlkjgt.b[2][0]++, !!val) && (cov_2b9jlkjgt.b[2][1]++, typeof val === 'object') && (cov_2b9jlkjgt.b[2][2]++, !isArray(val));
};
cov_2b9jlkjgt.s[17]++;
export var isString = function isString(s) {
  cov_2b9jlkjgt.f[7]++;
  cov_2b9jlkjgt.s[18]++;
  return typeof s === 'string';
};
cov_2b9jlkjgt.s[19]++;
export var isDate = function isDate(val) {
  cov_2b9jlkjgt.f[8]++;
  cov_2b9jlkjgt.s[20]++;
  return val instanceof Date;
};
cov_2b9jlkjgt.s[21]++;
export var isError = function isError(val) {
  cov_2b9jlkjgt.f[9]++;
  cov_2b9jlkjgt.s[22]++;
  return val instanceof Error;
};
cov_2b9jlkjgt.s[23]++;
export var isRegexp = function isRegexp(val) {
  cov_2b9jlkjgt.f[10]++;
  cov_2b9jlkjgt.s[24]++;
  return val instanceof RegExp;
};
export var isMap = (cov_2b9jlkjgt.s[25]++, nameIs('Map'));
export var isSet = (cov_2b9jlkjgt.s[26]++, nameIs('Set'));
export var isSymbol = (cov_2b9jlkjgt.s[27]++, nameIs('Symbol'));
cov_2b9jlkjgt.s[28]++;
export var isPromise = function isPromise(p) {
  cov_2b9jlkjgt.f[11]++;
  cov_2b9jlkjgt.s[29]++;
  return (cov_2b9jlkjgt.b[3][0]++, p) && ((cov_2b9jlkjgt.b[3][1]++, nameIs('Promise', p)) || (cov_2b9jlkjgt.b[3][2]++, isFunc(p.then)));
};
cov_2b9jlkjgt.s[30]++;
export var isValidKey = function isValidKey(key, object) {
  cov_2b9jlkjgt.f[12]++;
  cov_2b9jlkjgt.s[31]++;
  return key in object;
};
cov_2b9jlkjgt.s[32]++;
export var isInPath = function isInPath(val, path) {
  cov_2b9jlkjgt.f[13]++;
  cov_2b9jlkjgt.s[33]++;

  if (val === path) {
    cov_2b9jlkjgt.b[4][0]++;
    cov_2b9jlkjgt.s[34]++;
    return true;
  } else {
    cov_2b9jlkjgt.b[4][1]++;
  }

  cov_2b9jlkjgt.s[35]++;
  return (cov_2b9jlkjgt.b[5][0]++, path.indexOf("".concat(val, "[")) === 0) || (cov_2b9jlkjgt.b[5][1]++, path.indexOf("".concat(val, ".")) === 0);
};
cov_2b9jlkjgt.s[36]++;
export var isEmpty = function isEmpty(val) {
  cov_2b9jlkjgt.f[14]++;
  cov_2b9jlkjgt.s[37]++;

  if (val == null) {
    cov_2b9jlkjgt.b[6][0]++;
    cov_2b9jlkjgt.s[38]++;
    return true;
  } else {
    cov_2b9jlkjgt.b[6][1]++;
  }

  cov_2b9jlkjgt.s[39]++;

  if (isNan(val)) {
    cov_2b9jlkjgt.b[7][0]++;
    cov_2b9jlkjgt.s[40]++;
    return true;
  } else {
    cov_2b9jlkjgt.b[7][1]++;
  }

  cov_2b9jlkjgt.s[41]++;

  if (val.length !== undefined) {
    cov_2b9jlkjgt.b[8][0]++;
    cov_2b9jlkjgt.s[42]++;
    return val.length === 0;
  } else {
    cov_2b9jlkjgt.b[8][1]++;
  }

  cov_2b9jlkjgt.s[43]++;

  if (val instanceof Date) {
    cov_2b9jlkjgt.b[9][0]++;
    cov_2b9jlkjgt.s[44]++;
    return false;
  } else {
    cov_2b9jlkjgt.b[9][1]++;
  }

  cov_2b9jlkjgt.s[45]++;

  if (typeof val === 'object') {
    cov_2b9jlkjgt.b[10][0]++;
    cov_2b9jlkjgt.s[46]++;
    return Object.keys(val).length === 0;
  } else {
    cov_2b9jlkjgt.b[10][1]++;
  }

  cov_2b9jlkjgt.s[47]++;
  return false;
};
cov_2b9jlkjgt.s[48]++;
export var isBuffer = function isBuffer(val) {
  cov_2b9jlkjgt.f[15]++;
  cov_2b9jlkjgt.s[49]++;

  if ((cov_2b9jlkjgt.b[12][0]++, val) && (cov_2b9jlkjgt.b[12][1]++, typeof val === 'object') && (cov_2b9jlkjgt.b[12][2]++, val.constructor) && (cov_2b9jlkjgt.b[12][3]++, typeof val.constructor.isBuffer === 'function')) {
    cov_2b9jlkjgt.b[11][0]++;
    cov_2b9jlkjgt.s[50]++;
    return val.constructor.isBuffer(val);
  } else {
    cov_2b9jlkjgt.b[11][1]++;
  }

  cov_2b9jlkjgt.s[51]++;
  return false;
};
cov_2b9jlkjgt.s[52]++;
export var isMergeable = function isMergeable(val) {
  cov_2b9jlkjgt.f[16]++;
  cov_2b9jlkjgt.s[53]++;

  if (!isObject(val)) {
    cov_2b9jlkjgt.b[13][0]++;
    cov_2b9jlkjgt.s[54]++;
    return false;
  } else {
    cov_2b9jlkjgt.b[13][1]++;
  }

  var fns = (cov_2b9jlkjgt.s[55]++, [isDate, isError, isRegexp, isMap, isSet, isBuffer]);
  cov_2b9jlkjgt.s[56]++;

  for (var i = 0; i < fns.length; i++) {
    cov_2b9jlkjgt.s[57]++;

    if (fns[i](val)) {
      cov_2b9jlkjgt.b[14][0]++;
      cov_2b9jlkjgt.s[58]++;
      return false;
    } else {
      cov_2b9jlkjgt.b[14][1]++;
    }
  }

  cov_2b9jlkjgt.s[59]++;
  return true;
};
cov_2b9jlkjgt.s[60]++;
export var isOne = function isOne(val) {
  cov_2b9jlkjgt.f[17]++;
  cov_2b9jlkjgt.s[61]++;

  if (val === 1) {
    cov_2b9jlkjgt.b[15][0]++;
    cov_2b9jlkjgt.s[62]++;
    return true;
  } else {
    cov_2b9jlkjgt.b[15][1]++;
  }

  cov_2b9jlkjgt.s[63]++;
  return (cov_2b9jlkjgt.b[16][0]++, typeof val === 'string') && (cov_2b9jlkjgt.b[16][1]++, val.indexOf('.') !== -1) && (cov_2b9jlkjgt.b[16][2]++, parseFloat(val) === 1);
}; // /\d{1,3}%$/

cov_2b9jlkjgt.s[64]++;
export var isPercent = function isPercent(n) {
  cov_2b9jlkjgt.f[18]++;
  cov_2b9jlkjgt.s[65]++;
  return (cov_2b9jlkjgt.b[17][0]++, typeof n === 'string') && (cov_2b9jlkjgt.b[17][1]++, /\d{1,3}%$/.test(n));
};
cov_2b9jlkjgt.s[66]++;
export var isInseparable = function isInseparable(val) {
  cov_2b9jlkjgt.f[19]++;
  cov_2b9jlkjgt.s[67]++;
  return (cov_2b9jlkjgt.b[18][0]++, Object(val) !== val) || (cov_2b9jlkjgt.b[18][1]++, isFunc(val)) || (cov_2b9jlkjgt.b[18][2]++, isDate(val)) || (cov_2b9jlkjgt.b[18][3]++, isError(val)) || (cov_2b9jlkjgt.b[18][4]++, isSet(val)) || (cov_2b9jlkjgt.b[18][5]++, isMap(val)) || (cov_2b9jlkjgt.b[18][6]++, isRegexp(val));
};
cov_2b9jlkjgt.s[68]++;
export var isLink = function isLink(el) {
  cov_2b9jlkjgt.f[20]++;
  cov_2b9jlkjgt.s[69]++;

  if (typeof el === 'object') {
    cov_2b9jlkjgt.b[19][0]++;
    cov_2b9jlkjgt.s[70]++;

    if (!
    /*#__PURE__*/
    React.isValidElement(el)) {
      cov_2b9jlkjgt.b[20][0]++;
      cov_2b9jlkjgt.s[71]++;
      return false;
    } else {
      cov_2b9jlkjgt.b[20][1]++;
    }

    cov_2b9jlkjgt.s[72]++;

    if (!el.type) {
      cov_2b9jlkjgt.b[21][0]++;
      cov_2b9jlkjgt.s[73]++;
      return false;
    } else {
      cov_2b9jlkjgt.b[21][1]++;
    }

    cov_2b9jlkjgt.s[74]++;

    if (el.type === 'a') {
      cov_2b9jlkjgt.b[22][0]++;
      cov_2b9jlkjgt.s[75]++;
      return true;
    } else {
      cov_2b9jlkjgt.b[22][1]++;
    }

    cov_2b9jlkjgt.s[76]++;

    if ((cov_2b9jlkjgt.b[24][0]++, el.props) && (cov_2b9jlkjgt.b[24][1]++, el.props.to)) {
      cov_2b9jlkjgt.b[23][0]++;
      cov_2b9jlkjgt.s[77]++;
      return true;
    } else {
      cov_2b9jlkjgt.b[23][1]++;
    }
  } else {
    cov_2b9jlkjgt.b[19][1]++;
  }

  cov_2b9jlkjgt.s[78]++;
  return false;
};
cov_2b9jlkjgt.s[79]++;
export var isEnterPress = function isEnterPress(e) {
  cov_2b9jlkjgt.f[21]++;
  cov_2b9jlkjgt.s[80]++;

  if (typeof e !== 'object') {
    cov_2b9jlkjgt.b[25][0]++;
    cov_2b9jlkjgt.s[81]++;
    return false;
  } else {
    cov_2b9jlkjgt.b[25][1]++;
  }

  cov_2b9jlkjgt.s[82]++;
  return e.keyCode === 13;
};
cov_2b9jlkjgt.s[83]++;
export var isMacOS = function isMacOS() {
  cov_2b9jlkjgt.f[22]++;
  cov_2b9jlkjgt.s[84]++;
  return /macintosh|mac os x/i.test(navigator.userAgent);
};
cov_2b9jlkjgt.s[85]++;
export var isFirefox = function isFirefox() {
  cov_2b9jlkjgt.f[23]++;
  cov_2b9jlkjgt.s[86]++;
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
};